import { zodResolver } from '@hookform/resolvers/zod';
import { Group, Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Content, DateInputControl, Form, FormSubmit, TextInputControl } from '@/core/components';

import { ConferenceSchema } from './model/ConferenceSchema';

interface ConferenceFormProps extends FormSubmit<ConferenceSchema> {
  title: string;
}

export function ConferenceForm(props: ConferenceFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<ConferenceSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <TextInputControl<ConferenceSchema>
              name="conferenceName"
              label={t('conferences.form.fields.conferenceName')}
              isSubmitting={isSubmitting}
            />
            <Group>
              <DateInputControl<ConferenceSchema>
                label={t('conferences.form.fields.confStartDate')}
                name="confStartDate"
                isSubmitting={isSubmitting}
              />
              <DateInputControl<ConferenceSchema>
                label={t('conferences.form.fields.confEndDate')}
                name="confEndDate"
                isSubmitting={isSubmitting}
              />
            </Group>
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
